export function buildComposerMentionKeyDown({ mentionOpenRef, mentionFlatCountRef, setMentionActiveIndex, setMentionTrigger, setMentionAnchor }) {
  return (_view, event) => {
    if (!mentionOpenRef.current) return false
    const count = mentionFlatCountRef.current
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      setMentionActiveIndex((i) => (count > 0 ? (i + 1) % count : 0))
      return true
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault()
      setMentionActiveIndex((i) => (count > 0 ? (i - 1 + count) % count : 0))
      return true
    }
    if (event.key === 'Escape') {
      event.preventDefault()
      setMentionTrigger(null)
      setMentionAnchor(null)
      mentionOpenRef.current = false
      return true
    }
    return false
  }
}
